import { useState } from "react";
import API from "../services/api";
import "./AiChatPage.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Robot from "../component/AIAssistant/Robot";

function AiChatPage({ setCartCount }) {
    const [message, setMessage] = useState("");
    const [response, setResponse] = useState("");
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const askAi = async () => {
        if (!message.trim()) return;

        setLoading(true);

        try {
            const res = await API.post(
                "/api/ai/chat",
                message,
                {
                    headers: {
                        "Content-Type": "text/plain"
                    }
                }
            );

            setResponse(res.data.answer);
            setProducts(res.data.products || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const suggestions = [
        "Best gaming phone under 25000",
        "Best camera phone",
        "Best laptop under 50000"
    ];


    const handleToCart = async (productId) => {

        console.log("ADDING PRODUCT", productId);

        try {

            const result = await API.post(
                `/api/cart?productId=${productId}&quantity=1`
            );

            console.log(result.data);

            const response = await API.get("/api/cart");

            setCartCount(response.data.length);

            alert("Added to cart");

        } catch (error) {

            console.log(error);

            console.log(error.response);

            alert("Failed to add cart");
        }
    };

    return (

        <div className="ai-page">

            {!response && products.length === 0 && (

                <section className="ai-hero">

                    <div className="hero-glow hero-glow-left"></div>

                    <div className="hero-glow hero-glow-right"></div>

                    <motion.div
                        className="ai-hero-robot"
                        animate={{
                            y: [0, -15, 0]
                        }}
                        transition={{
                            duration: 3,
                            repeat: Infinity
                        }}
                    >

                        <Robot />

                    </motion.div>

                    <motion.h1
                        className="ai-title"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: .6 }}
                    >

                        ShopSphere AI

                    </motion.h1>

                    <motion.p
                        className="ai-subtitle"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: .2 }}
                    >

                        Your personal shopping assistant.

                        Search products using natural language,
                        compare products instantly,
                        discover the best offers,
                        and let AI help you choose the perfect product.

                    </motion.p>

                    <div className="ai-suggestions">

                        {suggestions.map((item, index) => (

                            <button
                                key={index}
                                onClick={() => setMessage(item)}
                            >

                                ✨ {item}

                            </button>

                        ))}

                    </div>

                </section>

            )}

            {loading && (

                <div className="ai-loading">

                    <span></span>
                    <span></span>
                    <span></span>

                </div>

            )}

            {(response || products.length > 0) && (

                <section className="ai-result-section">

                    {response && (

                        <motion.div
                            className="ai-response"
                            initial={{
                                opacity: 0,
                                y: 20
                            }}
                            animate={{
                                opacity: 1,
                                y: 0
                            }}
                        >

                            <div className="ai-response-header">

                                <Robot />

                                <div>

                                    <h3>ShopSphere AI</h3>

                                    <span>
                                        AI Shopping Assistant
                                    </span>

                                </div>

                            </div>

                            <div className="ai-response-content">

                                {response}

                            </div>

                        </motion.div>

                    )}

                    {products.length > 0 && (

                        <>

                            <div className="ai-products-title">

                                Recommended Products

                            </div>

                            <div className="ai-products-grid">

                                {products.map((product) => (

                                    <motion.div

                                        key={product.id}

                                        className="ai-product-card"

                                        whileHover={{
                                            y: -8
                                        }}

                                        transition={{
                                            duration: .25
                                        }}

                                        onClick={() =>
                                            navigate(`/product/${product.id}`)
                                        }

                                    >

                                        <div className="ai-product-image">

                                            <img
                                                src={product.imageUrl}
                                                alt={product.name}
                                            />

                                        </div>

                                        <div className="ai-product-content">

                                            <h4>

                                                {product.name}

                                            </h4>

                                            <p className="price">

                                                ₹{product.price}

                                            </p>

                                            <div className="ai-card-actions">

                                                <button

                                                    className="btn btn-outline-primary"

                                                    onClick={(e) => {

                                                        e.stopPropagation();

                                                        navigate(`/product/${product.id}`);

                                                    }}

                                                >

                                                    View Product

                                                </button>

                                                <button

                                                    className="btn btn-primary"

                                                    onClick={(e) => {

                                                        e.stopPropagation();

                                                        handleToCart(product.id);

                                                    }}

                                                >

                                                    Add to Cart

                                                </button>

                                            </div>

                                        </div>

                                    </motion.div>

                                ))}

                            </div>

                        </>

                    )}

                </section>

            )}

            <form

                className="ai-search-box"

                onSubmit={(e) => {

                    e.preventDefault();

                    askAi();

                }}

            >

                <input

                    type="search"

                    placeholder="Ask ShopSphere AI anything..."

                    value={message}

                    onChange={(e) =>
                        setMessage(e.target.value)
                    }

                    enterKeyHint="search"

                />

                <button

                    type="submit"

                    className="ai-send-btn"

                >

                    ➜

                </button>

            </form>

        </div>

    );
}
export default AiChatPage;